import axios from 'axios'
import {
  URL,
  getUrl
} from '@api/constants'
// const mockUser = {
//   id: 1,
//   serial: '003B000239',
//   name: 'First test customer',
//   icc_id: '',
//   created: '2019-03-05 15:14:32.894000',
//   channels: [{
//     id: 1,
//     name: 'Channel 1 (with camera)',
//     channelIndex: 0
//   }, {
//     id: 2,
//     name: 'Channel 2 (no camera)',
//     channelIndex: 1
//   }]
// }
class UsersClient {
  getUsers (pageNum, pageSize) {
    return axios.get(
      getUrl(URL.GET_USERS_LIST), {
        params: {
          pageNum,
          pageSize
        }
      })
  }
  getRoles () {
    return axios.get(
      getUrl(URL.GET_ROLES_LIST)
    )
  }
  getUser (id) {
    return axios.get(getUrl(URL.GET_USER, {
      id
    }))
  }
  postUser (customer) {
    return axios.post(getUrl(URL.POST_USER), customer)
  }
  putUser (id, customer) {
    return axios.put(getUrl(URL.PUT_USER, {
      id
    }), customer)
  }
  deleteUser (id) {
    return axios.delete(getUrl(URL.DELETE_USER, {
      id
    }))
  }
}

export let usersClient = new UsersClient()



// WEBPACK FOOTER //
// ./src/api/users.js